import { faPhone } from "@fortawesome/free-solid-svg-icons";
import { faChevronDown, faChevronUp } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { formatPhoneNumber } from "react-phone-number-input";
import GlobalStoreContext from "../../context/GlobalStoreContext";
import { Delivery } from "../../models/Delivery";
import TeamInfo from "../../teamInfo";
import UserInfo from "../../userInfo";
import TeamAvatar from "../Team/teamAvatar";

interface DamnInformationSectionProps {
    delivery: Delivery;
    receivingTeam: TeamInfo | null;
}

const DamnContactInformation: React.FC<DamnInformationSectionProps> = (props) => {
    const context = React.useContext(GlobalStoreContext);
    const [expandedSection, setExpandedSection] = React.useState<boolean>(true);

    const receivingTeamLeads: UserInfo[] =
        props.receivingTeam?.users.filter((user) => props.delivery.receivingTeamLeads.includes(user.id)) || [];

    return (
        <section className="mx-4 mt-4 mb-6">
            <div className="bg-white rounded-2xl shadow-xl border border-gray-200/50 overflow-hidden">
                <button
                    onClick={() => setExpandedSection(!expandedSection)}
                    className="cursor-pointer w-full p-5 flex items-center justify-between hover:bg-linear-to-r hover:from-gray-50 hover:to-white transition-all"
                >
                    <h3 className="text-sm font-bold text-gray-900 uppercase tracking-wider">Contact Information</h3>
                    <div
                        className={`p-1.5 rounded-lg transition-all ${
                            expandedSection ? "bg-[#ff9e00]/10" : "bg-gray-100"
                        }`}
                    >
                        {" "}
                        {expandedSection ? (
                            <FontAwesomeIcon icon={faChevronUp} className="text-plot-orange" />
                        ) : (
                            <FontAwesomeIcon icon={faChevronDown} className="text-plot-orange" />
                        )}
                    </div>
                </button>

                {expandedSection && (
                    <div className="px-5 pb-5 flex gap-2 flex-col bg-linear-to-b from-white to-gray-50">
                        <div className="flex flex-row justify-between  text-gray-700 items-center py-3 border-b border-gray-200">
                            <div className="font-bold w-1/3">Receiving Contractor Leads</div>
                            <TeamAvatar team={props.receivingTeam} size={40} showName={true} />
                        </div>
                        {context.userInfo ? (
                            <div className="flex flex-col items-end gap-2">
                                {props.receivingTeam && receivingTeamLeads.length > 0 ? (
                                    <div className="">
                                        {receivingTeamLeads.map((lead: UserInfo) => (
                                            <div key={lead.id} className="text-sm flex flex-col items-end">
                                                {lead.fullname}
                                                {lead.mobiles.length > 0 ? (
                                                    <div className="flex flex-row items-center gap-2 text-plot-orange">
                                                        <FontAwesomeIcon icon={faPhone} />
                                                        {formatPhoneNumber(lead.mobiles[0].mobile)}
                                                    </div>
                                                ) : (
                                                    ""
                                                )}
                                            </div>
                                        ))}
                                    </div>
                                ) : (
                                    <div className="text-sm">No leads specified</div>
                                )}
                            </div>
                        ) : null}
                    </div>
                )}
            </div>
        </section>
    );
};

export default DamnContactInformation;
